<template>
  <v-card outlined class="EntityCard hover-border">
    <v-toolbar :color="$app.opts.toolbarHeaderColor" flat dense>
      <slot name="header" :item="item">
        <v-toolbar-title class="subheading">{{ item.entity.display }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </slot>
    </v-toolbar>
    <v-card-text class="py-0">
      <slot name="entity" :item="item"></slot>
    </v-card-text>
    <v-card-text class="pt-2 pb-0" v-if="item.entity.users">
      <AvatarList :users="item.entity.users" align-right />
    </v-card-text>

    <v-card-actions>
      <EntityStatus :report="item.report" />
      <slot name="icons">
        <card-icons :entity="item.entity" v-if="item.entity.attachments" />
      </slot>
      <v-spacer></v-spacer>
      <v-btn small icon :to="show(item.entity)">
        <v-icon small v-text="$vuetify.icons.values.view" />
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import EntityStatus from './EntityStatus'
import { AvatarList } from '@argon/iam/components'
import CardIcons from './CardIcons'

export default {
  name: 'EntityCard',
  components: { EntityStatus, AvatarList, CardIcons },
  props: {
    item: { type: Object, required: true },
    show: { type: Function, required: true }
  }
}
</script>

<style scoped lang="scss">
.EntityCard {
  // max-width: 300px;

  ::v-deep .v-toolbar {
    background-color: transparent;

    .v-toolbar__content {
      padding: 0 16px;
    }
  }
}
</style>
